<script lang="ts">
  import { notifications } from '../stores/notifications';
  import NotificationItem from './NotificationItem.svelte';

  $: notificationList = $notifications;
</script>

<div class="notifications-container">
  {#each notificationList as notification (notification.id)}
    <NotificationItem
      {notification}
      onclose={() => notifications.remove(notification.id)}
    />
  {/each}
</div>

<style>
  .notifications-container {
    @apply fixed top-4 right-4 z-50 pointer-events-none;
  }

  .notifications-container :global(.notification) {
    @apply pointer-events-auto;
  }
</style>